import { defineMessages } from 'react-intl';

export default defineMessages({
  totalItemsOrderedLabel: {
    defaultMessage: 'Total Products Ordered',
    id: 'CXx+88',
    description: 'label that shows the total number of products ordered',
  },
  uniqueItemsOrderedLabel: {
    defaultMessage: 'Unique Products Ordered',
    id: '/Zbbl7',
    description: 'label that shows the total number of unique products ordered',
  },
  productsPerOrderLabel: {
    defaultMessage: 'Products per Order (Avg)',
    id: '4J0T0E',
    description: 'label that shows the average amount of products per order',
  },
});
